import { config } from "../constants";
import { authHeader } from "../helpers";
import { handleResponse } from "./handle-response";

export const productAvailabilities = ({}) => {
  const formData = new FormData();
  formData.append("file", csvFile);
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader() },
    body: formData,
  };

  return fetch(
    `${config.API_URL}/upload-product-availabilities-csv/`,
    requestOptions,
  ).then(handleResponse);
};

export const productDevelopment = (data) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(data || {}),
  };

  return fetch(`${config.API_URL}/product-developments/`, requestOptions).then(
    (response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.text(); // Return as text for CSV data
    }
  );
};

export const downloadProductAvailabilitiesCSV = (data) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(data || {}),
  };

  return fetch(`${config.API_URL}/product-availabilities/`, requestOptions).then(
    (response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.text(); // Return as text for CSV data
    }
  );
};

export const syncInteractiveEntry = ({}) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify({}),
  };

  return fetch(
    `${config.API_URL}/sync-interactive-entry/`,
    requestOptions,
  ).then(handleResponse);
};

export const getInteractiveMapLogs = () => {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };

  return fetch(
    `${config.API_URL}/admin/interactive-map-logs/`,
    requestOptions,
  ).then(handleResponse);
};

export const getAllProducts = () => {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };

  return fetch(`${config.API_URL}/admin/interactive-map-product/`, requestOptions).then(
    handleResponse
  );
};

// 2. Get products for a specific partner
// includeAll: if true, returns all active products (not just display_on_website) - for sales report tab visibility
export const getPartnerProducts = (partnerId, includeAll = false) => {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };

  let url = `${config.API_URL}/admin/interactive-map-product/partner_product/?partner_id=${partnerId}`;
  if (includeAll) {
    url += "&include_all=true";
  }
  return fetch(url, requestOptions).then(handleResponse);
};

// 3. Get partners for a specific product
export const getProductPartners = (productId) => {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };

  return fetch(
    `${config.API_URL}/admin/interactive-map-product/product_partner/?product_id=${productId}`,
    requestOptions
  ).then(handleResponse);
};

export const getExclusionData = () => {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };

  return fetch(`${config.API_URL}/admin/interactive-data-exclusion/`, requestOptions)
    .then(handleResponse)
    .then(data => {
      // Return the data object directly since that's what the API returns
      return data || {id: null};
    });
};

// 4. Patch exclusion config data
export const patchExclusionData = (payload, id) => {
  const requestOptions = {
    method: "PATCH",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };

  return fetch(`${config.API_URL}/admin/interactive-data-exclusion/${id}/`, requestOptions).then(
    handleResponse
  );
};

export const getAllActiveProductsData = () => {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };

  return fetch(`${config.API_URL}/admin/active-product/`, requestOptions)
    .then(handleResponse)
    .then(data => {
      // The API response should already be in the correct format
      // but we'll ensure it's returned as an array
      return Array.isArray(data) ? data : [];
    })
    .catch(error => {
      console.error('Error fetching active products:', error);
      throw error;
    });
};

export const updateDisplayOnWebsite = (activeProductId, flag) => {
  const requestOptions = {
    method: "PATCH",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify({ display_on_website: flag }),
  };

  return fetch(
    `${config.API_URL}/admin/active-product/${activeProductId}/`,
    requestOptions
  ).then(handleResponse);
};

export const updateERPFlag = (productId, flag) => {
  const requestOptions = {
    method: "PATCH",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify({ is_erp_approved: flag }),
  };

  return fetch(
    `${config.API_URL}/admin/interactive-map-product/${productId}/`,
    requestOptions
  ).then(handleResponse);
};

export const getInteractiveMapQuarters = () => {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };

  return fetch(`${config.API_URL}/interactive-map-quarters/`, requestOptions).then(
    handleResponse
  );
};

export const uploadProductDevelopmentCSV = (formData) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader() },
    body: formData, // Use the formData directly
  };

  return fetch(`${config.API_URL}/upload-product-development-csv/`, requestOptions).then(handleResponse);
};

export const uploadProductAvailabilitiesCSV = (formData) => {
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader() },
    body: formData,
  };

  return fetch(`${config.API_URL}/upload-product-availabilities-csv/`, requestOptions).then(handleResponse);
};

export const fetchDetailedCountryList = () => {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };

  return fetch(`${config.API_URL}/country_list/?is_detailed=true`, requestOptions).then(handleResponse);
};